import type {Asset} from '@hconnect/common'

import {groupAndSortAssets} from '@settings/modules/assets'

export const sortAssets = (assets: Asset[]): Asset[] =>
  Object.values(groupAndSortAssets(assets)).flatMap((assets) => assets)
